import { Component } from '@angular/core';
import { AlertController, App, NavController, NavParams } from 'ionic-angular';
import { XpReportService } from "../../services/xp-report.service";
import { XpWorkorderService } from "../../services/xp-workorder.service";
import { GymDataService, WorkoutTemplate } from "../../services/gym-data.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'page-xp-workorders',
  templateUrl: 'xp-workorders.html',
})
export class XpWorkordersPage {

  busy = false;
  templates: WorkoutTemplate[] = [];
  selectedTemplate = '';

  constructor(
    public app: App,
    public navCtrl: NavController,
    public navParams: NavParams,
    public reportService: XpReportService,
    public workorderService: XpWorkorderService,
    public gymData: GymDataService,
    public translate: TranslateService,
    public alertCtrl: AlertController
  ) {
  }

  /**
   * Gym flow: a new training does NOT open the old HVAC report stack. It lets
   * the athlete pick a workout template (or skip it) and then drops straight
   * into the scan / registrar flow.
   */
  public goToScan(){
    this.navCtrl.parent.select(3);
  }

  public chooseNewWorkorderType(){
    let buttons = [];
    let templates = this.gymData.templates();
    for(let i = 0; i < templates.length; i++){
      let template = templates[i];
      buttons.push({
        text: template.name,
        handler: () => {
          this.selectedTemplate = template.id;
          this.goToScan();
        }
      });
    }
    buttons.push({
      text: this.translate.instant('Sin plantilla'),
      handler: () => {
        this.selectedTemplate = '';
        this.goToScan();
      }
    });
    buttons.push({
      text: this.translate.instant('Cancelar'),
      role: 'cancel'
    });
    this.alertCtrl.create({
      title: this.translate.instant('Elegí tu entrenamiento'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public ionViewDidEnter() {
    console.log('ionViewDidEnter WorkordersPage (gym)');
    this.templates = this.gymData.templates();
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-workorders/xp-workorders.ts